import { render } from "./ChatsPage.vue?vue&type=template&id=0642bbf0&scoped=true"
import script from "./ChatsPage.vue?vue&type=script&lang=js"
export * from "./ChatsPage.vue?vue&type=script&lang=js"

import "./ChatsPage.vue?vue&type=style&index=0&id=0642bbf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0642bbf0"]])

export default __exports__